module.exports = __webpack_public_path__ + "img/no-pass-tip.c0aee339.svg";